import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Tooltip, UncontrolledTooltip } from 'reactstrap';
import ClipboardJS from 'clipboard';

import icons from '../../assets/icons';
import './styles.scss';

const CopyButton = ({ id, tooltip, onCopyResult, text, label, iconSrc = icons.copy }) => {
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimer = useRef(null);

  const reportCopied = useCallback(() => {
    onCopyResult?.('success');
    setIsCopied(true);

    clearTimeout(copiedTimer.current);
    copiedTimer.current = setTimeout(() => setIsCopied(false), 1000);
  }, [onCopyResult]);

  useEffect(() => {
    if (text !== undefined) {
      return () => clearTimeout(copiedTimer.current);
    }

    const clipboard = new ClipboardJS(`#copy-button-${id}`);
    clipboard.on('success', event => {
      event.clearSelection();
      reportCopied();
    });
    clipboard.on('error', () => onCopyResult?.('error'));

    return () => {
      clipboard.destroy();
      clearTimeout(copiedTimer.current);
    };
  }, [id, onCopyResult, reportCopied, text]);

  const copyText = async () => {
    try {
      await navigator.clipboard.writeText(text);
      reportCopied();
    } catch (error) {
      onCopyResult?.('error');
    }
  };

  const buttonLabel = isCopied && text !== undefined ? 'Copied' : tooltip || label || 'Copy';

  return (
    <div>
      <button type="button" id={`copy-button-${id}`} className="btn icon-button copy" data-clipboard-target={text === undefined ? `#${id}` : undefined} aria-label={buttonLabel} title={text === undefined ? undefined : buttonLabel} onClick={text === undefined ? undefined : copyText}>
        <img id={`copy-img-${id}`} src={isCopied && text !== undefined ? icons.check : iconSrc} alt="" />
        {label && <span aria-live="polite">{isCopied ? 'Copied' : label}</span>}
      </button>
      {text === undefined && (
        <Tooltip className="copy-feedback-tooltip" isOpen={isCopied} placement="top" target={`copy-button-${id}`} toggle={() => setIsCopied(false)} trigger="manual">
          Copied!
        </Tooltip>
      )}
      {text === undefined && tooltip && !isCopied && (
        <UncontrolledTooltip placement="top" target={`copy-img-${id}`}>
          {tooltip}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default CopyButton;
